(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("karcherServiceList", karcherServiceList);

  /** @ngInject */
  function karcherServiceList() {
    this.serviceList = function(data) {
      var filterData = counterList(data);
      var list = getValues(filterData);
      var serviceList = [];
      list.forEach(function(item) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("OPERATION_COUNTER_SERVICE_NAME_" + item):
              itemObj.serviceName = filterData[key];
              break;
            case key.includes("OPERATION_COUNTER_SERVICE_SECONDS_" + item):
              itemObj.serviceSeconds = filterData[key];
              break;
            case key.includes("OPERATION_COUNTER_SERVICE_DUE_" + item):
              itemObj.serviceDue = filterData[key];
              break;
          }
        }
        serviceList.push(itemObj);
      });
      return serviceList;
    };

    this.operationList = function(data) {
      var filterData = data;
      var serviceList = [];
      for (var i = 1; i < 99; i++) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("OPERATION_COUNTER_NAME_" + i):
              itemObj.name = filterData[key];
              break;
            case key.includes("OPERATION_COUNTER_SECONDS_" + i):
              itemObj.seconds = filterData[key];
              break;
          }
        }
        if (!angular.equals(itemObj, {})) {
          serviceList.push(itemObj);
        }
      }
      return serviceList;
    };

    this.pumpTypeList = function(data) {
      var filterData = pumpTypeList(data);
      var list = getValues(filterData);
      var serviceList = [];
      list.forEach(function(item) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("PUMP_TYPE_PROGRAM_NAME_" + item):
              itemObj.pumpName = filterData[key];
              break;
            case key.includes("PUMP_TYPE_PROGRAM_RUNTIME_T1_" + item):
              itemObj.pumpRunTime = filterData[key];
              break;
            case key.includes("PUMP_TYPE_PROGRAM_RUNTIME_T2_" + item):
              itemObj.pumpRunTimeHoliday = filterData[key];
              break;
          }
        }
        serviceList.push(itemObj);
      });
      return serviceList;
    };

    this.programList = function(data) {
      var filterData = filterProgramList(data);
      var programList = [],
        list = [];
      for (var k = 0; k < 12; k++) {
        list.push(k); // Expected number of items
      }
      for (var i = 0; i < filterData.length; i++) {
        for (var j = 0; j < list.length; j++) {
          var itemObj = {};
          for (var key in filterData[i]) {
            switch (true) {
              case key.includes("PROGRAM_NAME_" + list[j]):
                itemObj.programName = filterData[i][key];
                break;
              case key.includes("PROGRAM_COUNTER_" + list[j]):
                itemObj.seconds = filterData[i][key];
                break;
              case key.includes("name"):
                itemObj.name = filterData[i][key];
                break;
            }
          }
          if (Object.keys(itemObj).length > 1) {
            programList.push(itemObj);
          }
        }
      }
      return {
        boxName: programList[0].name,
        list: programList
      };
    };

    this.currentList = function(data) {
      var filterData = filterCurrentList(data);
      var list = getSimpleValues(data);
      var currentList = [];
      list.forEach(function(item) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("CURRENT_FAULT_NUMBER_" + item):
              itemObj.number = filterData[key];
              break;
            case key.includes("CURRENT_FAULT_" + item):
              itemObj.name = filterData[key];
              break;
          }
        }
        if (Object.keys(itemObj).length > 1) {
          currentList.push(itemObj);
        }
      });
      return currentList.slice(0, parseInt(data.CURRENT_FAULT_COUNT));
    };

    function counterList(data) {
      var serviceObj = {};
      for (var key in data) {
        if (key.includes("OPERATION_COUNTER_SERVICE_")) {
          serviceObj[key] = data[key];
        }
      }
      return serviceObj;
    }

    function pumpTypeList(data) {
      var serviceObj = {};
      for (var key in data) {
        if (key.includes("PUMP_TYPE_PROGRAM_")) {
          serviceObj[key] = data[key];
        }
      }
      return serviceObj;
    }

    function filterProgramList(data) {
      var washboxes = data.boxes,
        washBoxesArray = [];
      washboxes.forEach(function(washbox) {
        var washboxObj = {};
        washboxObj.name = washbox.name;
        for (var key in washbox) {
          if (key.includes("PROGRAM_NAME_")) {
            washboxObj[key] = washbox[key];
          } else if (key.includes("PROGRAM_COUNTER_")) {
            washboxObj[key] = washbox[key];
          }
        }
        washBoxesArray.push(washboxObj);
      });
      return washBoxesArray;
    }

    function filterCurrentList(data) {
      var currentObj = {};
      for (var key in data) {
        if (key.includes("CURRENT_FAULT_")) {
          currentObj[key] = data[key];
        }
      }
      return currentObj;
    }

    function getValues(data) {
      var values = [];
      var regex = /.*_(\d*_\d*)/g;

      for (var key in data) {
        var results = regex.exec(key);

        if (results !== null) {
          if (!values.includes(results[1])) {
            values.push(results[1]);
          }
        }
      }
      return values;
    }

    function getSimpleValues(data) {
      var values = [];
      var regex = /(\d)/g;

      for (var key in data) {
        var results = regex.exec(key);

        if (results !== null) {
          if (!values.includes(results[1])) {
            values.push(results[1]);
          }
        }
      }
      return values;
    }
  }
})();
